import {CommandCaller} from "../../../lib/commands"
import {Action} from "redux"
import {AsyncAction} from "../../../lib/types"
import {SubscriptionAppStore,ErrorField} from "./app"

export type SubscriptionAppAction = ChangeToSaveStateAction | FieldActionWrapper | SaveActionWrapper

export type ChangeToSaveStateAction = {
	type:'change to save state'
}

export type FieldAction = ChangeNameAction | ChangeOptionalAction | ChangeReasonAction

export type FieldActionWrapper = {
	type:'field action'
	action:FieldAction
}

export type ChangeNameAction = {
	type:'change name'
	name:string
}

export type ChangeOptionalAction = {
	type:'change optional'
	optional:boolean
}

export type ChangeReasonAction = {
	type:'change reason'
	reason:string
}

export type SaveAction = SaveSuccessAddAction | SaveSuccessEditAction | SaveFailureAction

export type SaveActionWrapper = {
	type:'save action'
	action:SaveAction
}

export type SaveSuccessAddAction = {
	type:'save add success'
	id:number
}

export type SaveSuccessEditAction = {
	type:'save edit success'
}

export type SaveFailureAction = {
	type:'save failure'
	errorFields:ErrorField[]
}

const wrapFieldAction = (action:FieldAction):FieldActionWrapper => ({
	type: 'field action',
	action: action
})

const wrapSaveAction = (action:SaveAction):SaveActionWrapper => ({
	type: 'save action',
	action: action
})

export const actionCreators = {
	state: {
		changeToSaveStateAction: ():ChangeToSaveStateAction => ({type: 'change to save state'})
	},

	field: {
		changeNameAction: (newName:string):FieldActionWrapper => wrapFieldAction({type: 'change name', name: newName}),
		changeOptionalAction: (newOptional:boolean):FieldActionWrapper => wrapFieldAction({type: 'change optional', optional: newOptional}),
		changeReasonAction: (newReason:string):FieldActionWrapper => wrapFieldAction({type: 'change reason', reason: newReason})
	},

	save: {
		saveSuccessAddAction: (id:number):SaveActionWrapper => wrapSaveAction({type: 'save add success', id: id}),
		saveSuccessEditAction: ():SaveActionWrapper => wrapSaveAction({type: 'save edit success'}),
		saveFailureAction: (errorFields:ErrorField[]):SaveActionWrapper => wrapSaveAction({type: 'save failure', errorFields:errorFields})
	}
}

export const onSave = (commandCaller:CommandCaller, onClose:() => void): AsyncAction<Action,SubscriptionAppStore> => {
	return async (dispatch:(_:SubscriptionAppAction) => Action,getState:() => SubscriptionAppStore) => {
		dispatch(actionCreators.state.changeToSaveStateAction())
		const state = getState();
		try {
			const r = await (commandCaller.runPost('subscriptionmanager.saveSubscription',{
				id: state.subscriptionId,
				name: state.name,
				optional: state.optional,
				reason: state.reason
			}) as Promise<{id:number, errorFields:ErrorField[]}> )
			if(r.errorFields.length > 0) {
				dispatch(actionCreators.save.saveFailureAction(r.errorFields))
			} else {
				state.subscriptionId == undefined
					? dispatch(actionCreators.save.saveSuccessAddAction(r.id))
					: dispatch(actionCreators.save.saveSuccessEditAction())
				onClose()

			}
		} catch (e) {
		}
	}
}



// WEBPACK FOOTER //
// ./src/subscriptionmanager/module/subscription-list/actions.ts